import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom'
import main from './main.jpg';
import main1 from './main1.jpg';
import main2 from './main2.jpg';
import main3 from './main3.jpg';
import eficiencia from './eficiencia.jpg';
import eficacia from './eficacia.jpg';
import efectividad from './efectividad.jpg';
import vocacion from './vocacion.png';
import './App.css';

class Home extends Component {
	render() {
		return (
			<Fragment>
				<div className="nav d-flex flex-column">
					<div className="nav-bar">
						<ul className="nav-list">
							<li><Link to="/" className="active">Inicio</Link></li>
							<li><Link to="/quienes-somos">Quienes somos</Link></li>
							<li><Link to="/sobre-nosotros">Sobre nosotros</Link></li>
						</ul>
					</div>
					<div className="static-banner">
						<img className="img-fluid" src={main} alt="main image" />
						{window.innerWidth >= 768 && (
							<div className="text-banner">
								<div className="opacity1 text-center">
									<h1>Mejorar sus costes, nuestra razón de ser</h1>
									<hr />
									<h3>Bienvenido a Celtia XXI</h3>
									<p>Y pague menos por lo mismo, o igual por algo mejor</p>
								</div>
							</div>
						)}
					</div>


				</div>
				<div className="main-wrapper">
					<div className="main">
						{window.innerWidth < 768 && (
							<div className="opacity1 text-center mb-4">
								<h1>Mejorar sus costes, nuestra razón de ser</h1>
								<hr />
								<h3>Bienvenido a Celtia XXI</h3>
								<p>Y pague menos por lo mismo, o igual por algo mejor</p>
							</div>
						)}

						<h2 className="text-center" style={{ marginTop: "0" }} >Qué le ofrecemos para lograrlo</h2>
						<div className="mb-5 text-center">Tres propuestas para optimizar su proceso de compras</div>
						<hr />
						<div className="row mt-5">
							<div className="col-12 col-md-6 col-xl-4 mb-3">
								<div className="static-banner2 mb-3">
									<img className="img-fluid" src={main1} alt="consultoría" />
								</div>
								<h3 className="text-center">Consultoría de compras</h3>
								<div className="pl-4">
									Analizamos a través de nuestra extensa base de datos de proveedores quienes ofrecen la mejor relación calidad/precio del producto que usted necesita adquirir.
								</div>
							</div>
							<div className="col-12 col-md-6 col-xl-4 mb-3">
								<div className="static-banner2 mb-3">
									<img className="img-fluid" src={main2} alt="consultoría" />
								</div>
								<h3 className="text-center">Distribución mayorista</h3>
								<div className="pl-4">
									Una vez presentada y aceptada la oferta que cumple con sus requerimientos técnicos y económicos la suministramos en el lugar de destino que nos indique.
								</div>
							</div>
							<div className="col-12 col-md-6 col-xl-4 mb-3">
								<div className="static-banner2 mb-3">
									<img className="img-fluid" src={main3} alt="consultoría" />
								</div>
								<h3 className="text-center">Logística integral</h3>
								<div className="pl-4">
									También podemos gestionarle el movimiento de mercancías que necesite transportar de puerta a puerta a través de nuestra red de operadores logísticos.
								</div>
							</div>
						</div>
					</div>

					<div className="main2-wrapper">
						<div className="main">
							<h2 className="mt-5 text-center">Con un modelo de gestión que trabaja por objetivos</h2>
							<div className="mb-5 text-center">Y un equipo con criterios claramente definidos</div>
							<hr />
							<div className="row mt-5">
								<div className="col-12 col-md-6 col-xl-3 mb-4">
									<h4 className="text-center">Eficiencia</h4>
									<div className="static-banner3">
										<img className="img-fluid mb-2" src={eficiencia} alt="consultoría" />
									</div>
									<div className="text-center">
										Conseguir los mejores precios en toda la cadena de suministro de cada propuesta.
								</div>
								</div>
								<div className="col-12 col-md-6 col-xl-3 mb-4">
									<h4 className="text-center">Eficacia</h4>
									<div className="static-banner3">
										<img className="img-fluid mb-2" src={eficacia} alt="consultoría" />
									</div>
									<div className="text-center">
										Seguimiento del cumplimiento en la forma y plazos acordados de las operaciones adjudicadas.
									</div>
								</div>
								<div className="col-12 col-md-6 col-xl-3 mb-4">
									<h4 className="text-center">Efectividad</h4>
									<div className="static-banner3">
										<img className="img-fluid mb-2" src={efectividad} alt="consultoría" />
									</div>
									<div className="text-center">
										Completar todo el proceso a su entera satisfacción.
									</div>
								</div>
								<div className="col-12 col-md-6 col-xl-3 mb-4">
									<h4 className="text-center">Vocación de servicio</h4>
									<div className="static-banner3">
										<img className="img-fluid mb-2" src={vocacion} alt="consultoría" />
									</div>
									<div className="text-center">
										Serle útil es nuestra mayor aspiración y esperamos tener la oportunidad de demostrárselo.
									</div>
								</div>
							</div>
						</div>
					</div>


				</div>
			</Fragment>
		);
	}
}

export default Home;


// WEBPACK FOOTER //
// ./src/Home.jsx